import { Mapper } from "../../../../../core/base";
import { PublicLocationWebEntity } from "./public-location.web-entity";
import { PublicLocation } from "../../../../../core/domain/models";

export class PublicLocationMapper extends Mapper<
  PublicLocationWebEntity,
  PublicLocation
> {
  mapFrom(param: PublicLocationWebEntity): PublicLocation {
    return {
      id: param.id,
      publicLocationId: param.publicLocationId,
      name: param.name,
      longitude: param.longitude,
      latitude: param.latitude,
      address: param.address,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      partialAddress: param.partialAddress,
      houseNo: param.houseNo,
      litra: param.litra,
      floor: param.floor,
      door: param.door
    };
  }

  mapTo(param: PublicLocation): PublicLocationWebEntity {
    return {
      id: param.id,
      publicLocationId: param.publicLocationId,
      name: param.name,
      longitude: param.longitude,
      latitude: param.latitude,
      address: param.address,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      partialAddress: param.partialAddress,
      houseNo: param.houseNo,
      litra: param.litra,
      floor: param.floor,
      door: param.door
    };
  }
}
